import { createRouter, createWebHistory } from 'vue-router'
// import LandingView from '../views/LandingView.vue'
// import WorkbookView from '../views/WorkbookView.vue'
import SignupView from '../views/SignupView.vue'
import LoginView from '../views/LoginView.vue'
import LogoutView from '../views/LogoutView.vue'
import PhoneVerifyView from '../views/PhoneVerifyView.vue'
import EventsLogs from '@/views/EventsLogs.vue'
import { useUserStore } from '../stores/user'

function determineDefaultLayout(role: string): string {
  if (role === 'clinician') {
    return 'clinician'
  } else if (role === 'admin') {
    return 'admin'
  } else if (role === 'user') {
    return 'dashboard'
  }
  return 'dashboard'
}

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/HomeView.vue'),
    meta: { layout: 'main' }
  },
  {
    path: '/faq',
    name: 'faq',
    component: () => import('../views/FaqView.vue'),
    meta: { layout: 'main' }
  },
  {
    path: '/privacy',
    name: 'privacy policy',
    component: () => import('../views/PrivacyView.vue'),
    meta: { layout: 'main' }
  },
  {
    path: '/contact',
    name: 'contact us',
    component: () => import('../views/ContactView.vue'),
    meta: { layout: 'main' }
  },
  {
    path: '/resources',
    name: 'Other Resources',
    component: () => import('../views/ResourcesView.vue'),
    meta: { layout: 'main' }
  },
  {
    path: '/notes',
    name: 'notes',
    component: () => import('../views/NotesView.vue'),
    meta: { requiresRole: ['user'], layout: 'dashboard' }
  },
  // {
  //   path: '/terms',
  //   name: 'terms and conditions',
  //   component: () => import('../views/TermsView.vue'),
  //   meta: { layout: 'main' }
  // },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (About.[hash].js) for this route
    // which is lazy-loaded when } the route is visited.
    component: () => import('../views/AboutView.vue'),
    meta: { layout: 'main' }
  },
  { name: 'signup', path: '/signup', component: SignupView, meta: { layout: 'auth' } },
  { name: 'login', path: '/login', component: LoginView, meta: { layout: 'auth' } },
  { name: 'logout', path: '/logout', component: LogoutView, meta: { layout: 'auth' } },
  { name: 'verify', path: '/verify', component: PhoneVerifyView, meta: { layout: 'auth' } },
  // { path: '/landing', component: LandingView },
  {
    path: '/workbook',
    name: 'workbook',
    component: () => import('../views/WorkbookView.vue'),
    meta: { requiresRole: ['user'], layout: 'dashboard' }
  },
  {
    name: 'sheet-view',
    path: '/modules/:chapter_id/activity/:id',
    component: () => import('../views/ActivityView.vue'),
    meta: { requiresRole: ['user'], layout: 'dashboard' }
  },
  {
    name: 'sheets',
    path: '/modules/:chapter_id',
    component: () => import('../views/SheetsView.vue'),
    meta: { requiresRole: ['user'], layout: 'dashboard' }
  },
  {
    name: 'sheet',
    path: '/modules/:chapter_id/sheet/:sheet_id/view',
    component: () => import('../views/SheetView.vue'),
    meta: { requiresRole: ['user'], layout: 'dashboard' }
  },
  {
    name: 'completed-modules',
    path: '/completed-modules',
    component: () => import('../views/CompletedModulesView.vue'),
    meta: { requiresRole: ['user'], layout: 'dashboard' }
  },
  {
    name: 'account',
    path: '/account',
    component: () => import('../views/AccountView.vue'),
    meta: { requiresRole: ['clinician', 'admin', 'user'], layout: 'dynamic' }
  },
  {
    name: 'purchase',
    path: '/purchase',
    component: () => import('../views/PurchaseView.vue'),
    meta: { layout: 'dashboard' }
  },
  {
    name: 'payment-complete',
    path: '/payment-complete',
    component: () => import('../views/ProcessPaymentView.vue'),
    meta: { layout: 'dashboard' }
  },
  // {
  //   name: 'payment-cancelled',
  //   path: '/payment-cancelled',
  //   component: () => import('../views/CancelledPaymentView.vue'),
  //   meta: { layout: 'dashboard' }
  // },
  {
    name: 'crisis-plan',
    path: '/crisis-plan',
    component: () => import('../views/CrisisPlanView.vue'),
    meta: { layout: 'dashboard' }
  },
  {
    name: 'my-hope-kit',
    path: '/my-hope-kit',
    component: () => import('../views/MyHopeKitView.vue'),
    meta: { layout: 'dashboard' }
  },
  {
    path: '/clinician',
    component: () => import('../views/clinician/Home.vue'),
    meta: { requiresRole: ['clinician'], layout: 'clinician' }
  },
  {
    name: 'clinician-modules-to-review',
    path: '/clinician/modules-to-review',
    component: () => import('../views/clinician/ModulesToReview.vue'),
    meta: { requiresRole: ['clinician'], layout: 'clinician' }
  },
  {
    name: 'clinician-unread-messages',
    path: '/clinician/unread-messages',
    component: () => import('../views/clinician/UnreadMessages.vue'), //change this to unread messages vue
    meta: { requiresRole: ['clinician'], layout: 'clinician' }
  },
  {
    name: 'clinician-list-users',
    path: '/clinician/users',
    component: () => import('../views/clinician/ClinicianListUsers.vue'), //change this to unread messages vue
    meta: { requiresRole: ['clinician'], layout: 'clinician' }
  },
  {
    name: 'clinician-user-messages',
    path: '/clinician/user-messages/:id',
    props: true,
    component: () => import('../views/clinician/ClinicianMessages.vue'),
    meta: { requiresRole: ['clinician'], layout: 'clinician' }
  },
  {
    name: 'clinician-user-completed-activities',
    path: '/clinician/user-completed-activities/:id',
    props: true,
    component: () => import('../views/clinician/CompletedActivities.vue'),
    meta: { requiresRole: ['clinician'], layout: 'clinician' }
  },
  {
    name: 'clinician-event-logs',
    path: '/clinician/event-logs',
    component: () => import('../views/EventsLogs.vue'),
    meta: { requiresRole: ['clinician'], layout: 'clinician' }
  },
  {
    name: 'clinician-review-progress',
    path: '/clinician/review-progress/:id',
    props: true,
    component: () => import('../views/clinician/ReviewCompletedSheet.vue'),
    meta: { requiresRole: ['clinician'], layout: 'clinician' }
  },
  {
    path: '/admin',
    component: () => import('../views/admin/AdminHomeView.vue'),
    meta: { requiresRole: ['admin'], layout: 'admin' }
  },
  {
    name: 'admin-modules',
    path: '/admin/modules',
    component: () => import('../views/admin/AdminModulesView.vue'),
    meta: { requiresRole: ['admin'], layout: 'admin' }
  },
  {
    path: '/admin/modules/new',
    component: () => import('../views/admin/AdminModulesNew.vue'),
    meta: { requiresRole: ['admin'], layout: 'admin' }
  },
  {
    name: 'admin-module-view', // name is required for router-link to work with params
    path: '/admin/modules/:id',
    component: () => import('../views/admin/AdminModuleView.vue'),
    meta: { requiresRole: ['admin'], layout: 'admin' }
  },
  {
    name: 'admin-module-edit',
    path: '/admin/modules/:id/edit',
    component: () => import('../views/admin/AdminModuleEdit.vue'),
    meta: { requiresRole: ['admin'], layout: 'admin' }
  },
  {
    name: 'admin-sheets-new', // name is required for router-link to work with params
    path: '/admin/modules/:chapter_id/sheets/new',
    component: () => import('../views/admin/AdminSheetNew.vue'),
    meta: { requiresRole: ['admin'], layout: 'admin' }
  },
  {
    name: 'admin-sheet-edit', // name is required for router-link to work with params
    path: '/admin/modules/:chapter_id/sheets/:id/edit',
    component: () => import('../views/admin/AdminSheetEdit.vue'),
    meta: { requiresRole: ['admin'], layout: 'admin' }
  },
  {
    name: 'admin-sheet-preview', // name is required for router-link to work with params
    path: '/admin/modules/:chapter_id/sheets/:id/preview',
    component: () => import('../views/admin/AdminSheetPreview.vue'),
    meta: { requiresRole: ['admin'], layout: 'admin' }
  },
  {
    name: 'admin-users-list',
    path: '/admin/users',
    component: () => import('../views/admin/AdminUsersView.vue'),
    meta: { requiresRole: ['admin'], layout: 'admin' }
  },
  {
    name: 'admin-users-edit',
    path: '/admin/users/:id/edit',
    component: () => import('../views/admin/AdminUserEdit.vue'),
    meta: { requiresRole: ['admin'], layout: 'admin' }
  },
  { path: '/:pathMatch(.*)*', redirect: '/' }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth'
      }
    }
    return { top: 0, behavior: 'smooth' }
  }
})

router.beforeEach(async (to, from, next) => {
  const requiredRoles = to.meta.requiresRole as [string] | undefined
  if (requiredRoles !== undefined) {
    const userStore = useUserStore()
    const u = await userStore.getCurrentUser()
    if (u === null) {
      next('/login')
      return
    }
    if (!requiredRoles.includes(u.role)) {
      console.log(u.role)
      console.log('Missing Role ' + u.role + ', redirecting to login')
      if (u.role === 'admin') next('/admin')
      else if (u.role === 'clinician') next('/clinician')
      else if (u.role === 'user') next('/workbook')
      else next('/login')
      return
    }
    if (to.meta.layout === 'dynamic') to.meta.layout = determineDefaultLayout(u.role)
  }
  next()
})

export default router
